import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "card mb-5 mb-xl-10",
  id: "kt_profile_details_view"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header cursor-pointer" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Modalidad de Pago")
  ])
], -1)
const _hoisted_3 = { class: "card-body p-9" }
const _hoisted_4 = { class: "row mb-7" }
const _hoisted_5 = {
  key: 0,
  class: "notice d-flex bg-light-danger rounded border-danger border border-dashed p-6 mb-20"
}
const _hoisted_6 = { class: "svg-icon svg-icon-2tx svg-icon-danger me-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack flex-grow-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "fs-6 text-gray-600" }, " Atención. Su cuenta se encuentra bloqueada o con observaciones. Esto puede generar que sus documentos no sean pagados. ")
  ])
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-3 fw-bold text-muted" }, "Banco", -1)
const _hoisted_9 = { class: "col-lg-3" }
const _hoisted_10 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-3 fw-bold text-muted" }, "Cuenta", -1)
const _hoisted_12 = { class: "col-lg-3" }
const _hoisted_13 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_14 = { class: "notice d-flex bg-light-warning rounded border-warning border border-dashed p-6" }
const _hoisted_15 = { class: "svg-icon svg-icon-2tx svg-icon-warning me-4" }
const _hoisted_16 = { class: "d-flex flex-stack flex-grow-1" }
const _hoisted_17 = { class: "fw-bold" }
const _hoisted_18 = { class: "fs-6 text-gray-600" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Skeleton = _resolveComponent("Skeleton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_ctx.currentProveedor.bloqueado == 'S')
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen044.svg" })
              ]),
              _hoisted_7
            ]))
          : _createCommentVNode("", true),
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.currentProveedor.medioNombre), 1),
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_Skeleton, {
                key: 0,
                class: "mb-2"
              }))
            : _createCommentVNode("", true)
        ]),
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.currentProveedor.medioCuenta), 1),
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_Skeleton, {
                key: 0,
                class: "mb-2"
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_Skeleton, {
            key: 0,
            class: "mb-2",
            height: "4rem"
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("span", _hoisted_15, [
          _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen044.svg" })
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.currentProveedor.condicionNombre), 1)
          ])
        ])
      ])
    ])
  ]))
}